<template>
  <div class="nav nav-settings">
    <div class="nav-icon non-active">
      <font-awesome-icon icon="cog" />
      <div class="settings-foldout">
        <div class="arrow"></div>
        <div class="menu-content">
          <router-link :to="{ name: 'switcher' }">
            <a href="#" class="menu-item">
              Andere organisatie
            </a>
          </router-link>
          <div v-if="currentNetworkId" class="field">
            <label>Ander netwerk:</label>
            <select id="network-select" class="config-select" style="color: #000" v-model="currentNetworkId">
              <option v-for="item in networks" :key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div id="localization-field" class="field">
            <div id="localization" style="position: relative; top: 0; left: 0;">
              <a v-for="locale in $i18n.availableLocales"
                 :key="`locale-${locale}`"
                 @click="updateLocale(locale)"
                 :style="$i18n.locale === locale ? 'border: solid 1px #bfbdbd;' : ''"
              >
                <img :src="blankFlag" :class="`flag flag-${locale}`" :alt="locale" />
              </a>
            </div>
          </div>
          <router-link :to="{ name: 'profile' }">
            <a href="#" class="menu-item">
              Profiel bekijken
            </a>
          </router-link>
          <router-link :to="{ name: 'logout' }">
            <a href="#" class="menu-item">
              Uitloggen
            </a>
          </router-link>
        </div>
        <div class="padding"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import blankFlag from '../../assets/img/language/blank.png';
import authService from '@/services/auth';
import UserApi from '@/api/user';
import axios from '@/plugins/axios';
import EventBus from '@/events/event-bus';

export default {
  name: 'Settings',
  props: {
    network: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
      networkId: 'settings/getNetworkId',
    }),
  },
  data() {
    return {
      blankFlag,
      networks: [],
      currentNetworkId: this.network ? this.network.id : null,
    };
  },
  methods: {
    ...mapActions({
      resetCachedMap: 'map/resetMap',
    }),
    updateLocale(locale) {
      this.$i18n.locale = locale;
      authService.setLocale(locale);
    },
  },
  mounted() {
    console.log('settings mounted', this.networkId, this.currentNetworkId);
    if (this.user && this.user.id) {
      UserApi.getNetwork(this.user.id)
        .then((response) => {
          this.networks = response.data.sort((a, b) => a.name.localeCompare(b.name));
        });
    }
  },
  watch: {
    async currentNetworkId(newNetworkId) {
      if (!newNetworkId) {
        return;
      }
      axios.defaults.headers['x-network'] = newNetworkId;
      await this.$store.dispatch('switcher/setNetworkId', newNetworkId);
      await this.resetCachedMap();
      await this.$store.dispatch('settings/fetchNetwork');
      EventBus.$emit('Map.clearMap');
      EventBus.$emit('Filter.reset');
      await this.$store.dispatch('settings/forceFetchAllNetwork');
      await this.$store.dispatch('selected/resetMapObject');
      await this.$store.dispatch('selected/resetSelection');
      await this.$store.dispatch('getUser');
      this.$emit('showFullscreen', false);
      // EventBus.$emit('Map.redraw');
      if (this.$route.name !== 'route_management') {
        await this.$router.push({ name: 'home' });
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
}
#localization-field {
  line-height: 0;
  padding: 8px 10px 8px;
  flex-direction: column;
  align-items: center;
  display: flex;
}
#localization a {
  background: rgba(255, 255, 255, 0.15) none repeat scroll 0 0;
  border: 1px solid white;
  border-radius: 50%;
  display: block;
  float: left;
  height: 34px;
  line-height: 34px;
  margin-right: 7px;
  text-align: center;
  width: 34px;
}

#localization a:hover {
  background: white none repeat scroll 0 0;
}

#localization a.active, #localization a.active:hover {
  background: rgba(255, 255, 255, 0.5) none repeat scroll 0 0;
}

#localization .flag {
  display: inline-block;
  position: relative;
  top: 13%;
  transform: translateY(-50%);
  width: 16px;
  height: 11px;
  background: url("../../assets/img/language/flags.png") no-repeat;
}

#localization .flag.flag-en {
  background-position: -16px 0;
}

#localization .flag.flag-de {
  background-position: 0 0;
}

#localization .flag.flag-nl {
  background-position: 0 -11px;
}
</style>
